var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQueryClient } from '@tanstack/react-query';
import { accountSummaryV2CacheKey, usePaymentQuery } from 'syf-api';
import { useActivityContext } from '../context/activity-store';
import { cancelPaymentQuery, paymentQueryCacheKey } from '../helpers/cancel-payment-query';
import { activityURL } from '../services/activity/activity-api';
var useCancelPayment = function (paymentId) {
    var _a = useActivityContext(), accountId = _a.accountId, accountIdType = _a.accountIdType, config = _a.config;
    var queryClient = useQueryClient();
    var paymentQueryEnabled = accountId !== undefined && paymentId !== '';
    var paymentQueryKeyProps = {
        accountId: accountId,
        accountIdType: accountIdType,
        paymentId: paymentId
    };
    var usePaymentQueryArgs = {
        config: config,
        keyProps: { accountId: accountId, accountIdType: accountIdType },
        queryOptions: {
            enabled: paymentQueryEnabled,
            queryKey: paymentQueryCacheKey(__assign({}, paymentQueryKeyProps)),
            queryFn: cancelPaymentQuery(__assign({ config: config }, paymentQueryKeyProps)),
            onSuccess: function () {
                Promise.all([
                    queryClient.invalidateQueries(accountSummaryV2CacheKey({ accountId: accountId, accountIdType: accountIdType })),
                    queryClient.invalidateQueries([
                        activityURL,
                        { accountId: accountId, accountIdType: accountIdType }
                    ])
                ]);
            }
        }
    };
    var _b = usePaymentQuery(usePaymentQueryArgs), cancelPaymentError = _b.isError, cancelPaymentFetching = _b.isFetching, cancelPaymentSuccess = _b.isSuccess;
    return {
        cancelPaymentError: cancelPaymentError,
        cancelPaymentFetching: cancelPaymentFetching,
        cancelPaymentSuccess: cancelPaymentSuccess
    };
};
export default useCancelPayment;
//# sourceMappingURL=use-cancel-payment.js.map